var $ = require("../lib/jquery-1.11.2.mod.js");
var console = require("../lib/logger.js");
var Util = require("../lib/util.js");
var configModule = require("../define/config.js");

function topBarHelperFunction (extensionFrameProxy) {

    var topBarId = "_topBarFrame";
    var topBarUrl, topBarStyle, topBarObj;

    var topbarDefaultStyle = {
        "font-family":"Arial, Tahoma",
        "position":"fixed",
        "z-index":"2147483647",
        "top":"0",
        "left":"auto",
        "right":"15px",
        "width":"326px",
        "height":"475px",
        "min-height":"158px",
        "border":"0px",
        "background-color":"transparent",
        "visibility":"hidden",
        "overflow":"hidden",
        "display":"block"
    };

    if (Util.isIE() === true) {

        if (Util.isDocModeBelow(9) === true) {

            topbarDefaultStyle["border"] = "1px solid #CCCCCC";
        }

        if (Util.isDocModeBelow(6) === true) {

            topbarDefaultStyle["position"] = "absolute";
        }
    }
        

    var topbarDefaultMobileStyle = {
        "font-family":"Arial, Tahoma",
        "position":"fixed",
        "z-index":"2147483647",
        "top":"0",
        "left":"0",
        "width":"100%",
        "height":"100%",
        "border":"0px",
        "background-color":"transparent",
        "visibility":"hidden",
        "overflow":"hidden",
        "display":"block"
    };

    var getTopBarTemplate = function (isInMobile) {
        
        if(isInMobile){
            topBarStyle = topbarDefaultMobileStyle;
            topBarUrl = configModule.TOPBAR_MOBILE_HTML;
        }else{
            topBarStyle = topbarDefaultStyle;
            topBarUrl = configModule.TOPBAR_HTML;
        }

        var template = $("<iframe/>")
                            .attr("id",topBarId)
                            .attr("name",topBarId)
                            .attr("src",topBarUrl)
                            .attr("scrolling","no")
                            .css(topBarStyle); 

        // IE 8 and below
        if (Util.isIE() === true &&
            Util.isDocModeBelow(9) === true) {

            template.attr("frameborder", "0");
        }

        return template;
    };


    extensionFrameProxy.onMessage("OpenTopBar", function (messageObj, messageProxy) {
        console.log(__GLOBAL_LOG_PREFIX__, "[TopFrame] OpenTopBar!");

        var template = getTopBarTemplate(messageObj.message.isInMobile);
        $("body").append(template);
        console.log(__GLOBAL_LOG_PREFIX__, "[TopFrame] topbar appended");

        topBarObj = $("#"+topBarId);
    });

    extensionFrameProxy.onMessage("ShowTopBar", function (messageObj, messageProxy) {

        console.log(__GLOBAL_LOG_PREFIX__, "[TopFrame] ShowTopBar!");

        topBarObj.css({visibility: "visible"});

        setTimeout(function(){
            // to set focus on iframe
            topBarObj.focus();
            extensionFrameProxy.postMessage("TopBarShown", messageObj.message);
        }, 0);

    });

    extensionFrameProxy.onMessage("HideTopBar", function () {

        console.log(__GLOBAL_LOG_PREFIX__, "[TopFrame] HideTopBar!");

        topBarObj.css({visibility: "hidden"});
    });

    extensionFrameProxy.onMessage("ResizeTopBar", function (messageObj, messageProxy) {

        console.log(__GLOBAL_LOG_PREFIX__, "[TopFrame] ResizeTopBar! : ", messageObj.message);

        var size = messageObj.message;

        var height = size.height || topBarStyle.height;
        var width = size.width || topBarStyle.width;

        topBarObj.height(height);
        topBarObj.width(width);
    });  

    extensionFrameProxy.onMessage("StyleTopBar", function (messageObj, messageProxy) {

        console.log(__GLOBAL_LOG_PREFIX__, "[TopFrame] StyleTopBar! : ", messageObj.message);

        var style = messageObj.message;

        topBarObj.css(style);
    });  

    extensionFrameProxy.onMessage("CloseTopBar", function () {

        console.log(__GLOBAL_LOG_PREFIX__, "[TopFrame] CloseTopBar!");

        topBarObj.remove();
    });
}

module.exports = topBarHelperFunction;